/** модуль аналитики */
export default {
    /**
     * состояния
     * 
     */
    state: {

    },
    mutations: {

    },
}